module.exports = __webpack_public_path__ + "media/images/airtel-grey-43506e351768a32be0ad255ef10f14d8.jpeg";